import { Demographic } from '@/common/models';
import API from '@/org-app/api';
import {
  createAuditAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewDemographic({ commit }, demographic = Demographic.fromObject({ id: -1, name: '' })) {
    commit(types.CREATE_DEMOGRAPHIC, demographic);
    return demographic;
  },
  getDemographics: createGetAllAction(
    API.instance.getDemographics,
    types.UPDATE_DEMOGRAPHICS_LIST,
    'messages.failedToGetDemographics',
    false,
  ),
  getDemographic: createGetOneAction(
    API.instance.getDemographic,
    types.SAVE_DEMOGRAPHIC,
    'messages.failedToGetDemographic',
  ),
  createDemographics: createPostAction(
    API.instance.postDemographics,
    types.SAVE_DEMOGRAPHIC,
    'messages.failedToCreateDemographic',
  ),
  updateDemographic: createPutAction(
    API.instance.putDemographic,
    types.SAVE_DEMOGRAPHIC,
    'messages.failedToUpdateDemographic',
  ),
  deleteDemographic: createDeleteAction(
    API.instance.deleteDemographic,
    types.DELETE_DEMOGRAPHIC,
    'messages.failedToDeleteDemographic',
  ),
  getDemographicAudit: createAuditAction(API.instance.getDemographicAudit, 'messages.failedToGetDemographicAudit'),
};
